export const completedCartsConfig = {
  testKey: '__test',
  collectionKey: 'completed_carts',
  resourceKeyPrefix: 'completed_cart:',
  ttlDays: 7,
} as const
